import { ALIcons } from '@af-lib/vue-ui';
import { type IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import {
  faBolt,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClock,
  faCopy,
  faEarthAmericas,
  faEnvelope,
  faFile,
  faHeart,
  faLock,
  faPerson,
  faPersonDress,
  faPlay,
  faPlus,
  faSpinner
} from '@fortawesome/pro-solid-svg-icons';
import {
  faArrowRightFromBracket as faThinArrowRightFromBracket,
  faArrowUpFromBracket,
  faBolt as faThinBolt,
  faCircleCheck as faThinCircleCheck,
  faCircleExclamation as faThinCircleExclamation,
  faCircleQuestion as faThinCircleQuestion,
  faCircleXmark as faThinCircleXmark,
  faClock as faThinClock,
  faEye as faThinEye,
  faEyeSlash as faThinEyeSlash,
  faLock as faThinLock,
  faMagnifyingGlass,
  faPartyHorn,
  faStar as faThinStar,
  faStars as faThinStars,
  faTriangleExclamation as faThinTriangleExclamation,
  faXmark
} from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { App, Component } from 'vue';

export default function (app: App) {
  library.add(
    ...(ALIcons as never[]),
    faEarthAmericas,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faCircleXmark,
    faFile,
    faLock,
    faEnvelope,
    faClock,
    faCheck,
    faPlay,
    faPlus,
    faCopy,
    faSpinner,
    faBolt,
    faPerson,
    faPersonDress,
    faHeart,
    faXmark,
    faMagnifyingGlass,
    faArrowUpFromBracket,
    faPartyHorn,
    faThinArrowRightFromBracket,
    faThinBolt,
    faThinCircleCheck,
    faThinCircleExclamation,
    faThinCircleQuestion,
    faThinCircleXmark,
    faThinClock,
    faThinLock,
    faThinEye,
    faThinEyeSlash,
    faThinStar,
    faThinStars,
    faThinTriangleExclamation
  );

  library.add(ALIcons as IconDefinition[]);
  app.component('FaIcon', FontAwesomeIcon as Component);
}
